import Typography from '../../components/typography/Typography'
// import { Typography } from '@mui/material';
import appLogo from '../../assets/logo/app-logo.svg'
import { useDispatch, useSelector } from 'react-redux'
import '../login/login.scss'
import useScreenSize from '../../hooks/useScreenSize'
import { getConfiguration } from '../../store/builders/configuration/configuration.builder'
import { useEffect } from 'react'
import phoneSVG from '../../assets/icons/phone.svg'
import mailSVG from '../../assets/icons/mail.svg'

function ContactUs() {
    const screenSize = useScreenSize()
    const dispatch = useDispatch()
    const configurationData = useSelector((state) => state?.configuration?.configurationData?.configration)
    useEffect(() => {
        dispatch(getConfiguration())
        return () => dispatch({ type: 'configuration/clearExtraReducers' })
    }, [dispatch])

    return (
        <div className='wrapper'>
            <div className='container flex justify-center align-center'>
                <div className='section logo-section flex justify-center align-center'>
                    <div className='container'>
                        <img src={appLogo} alt='App Logo' />
                    </div>
                </div>
                <div className='section login-section flex justify-center align-center'>
                    <div className={`container ${screenSize} flex flex-column justify-evenly`}>
                        <WelcomeText
                            title='Contact us'
                            //   message='We`d love to hear from you. Reach out with any questions or feedback!'
                            message='How can we help you?'
                            configurationData={configurationData}
                            subMessage='We`re here to  help and answer any questions you might have we look forward to hearing from you!'
                        />
                        <div className='input-wrapper flex flex-column justify-center align-center'>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactUs


export function WelcomeText({
    message,
    title,
    configurationData,
    subMessage
}) {
    const dispatch = useDispatch()

    return (
        <div className='heading-wrapper flex flex-column justify-center'>
          <Typography justify='left' textType='welcome' textWeight='700'>
                {title}
            </Typography>
            <Typography justify='left' textColor='red' textType='description'>
                {message}
            </Typography>
            <div className='subMessage'>
                {subMessage}
            </div>
            {/* <hr style={{ color: 'lightslategray', width: '100%', height:'2px' }} /> */}
            <div className='info'>
                <div><img src={mailSVG} height={20} width={20} /></div> {configurationData?.contact_us_email}
            </div>
            <div className='info'>
                <div><img src={phoneSVG} height={20} width={20} /></div>{configurationData?.contact_us_phone}
            </div>
        </div>
    )
}

